// 检查邮箱

export var checkMail=(rule, email, callback)=>{
  if(email){
    const emailRegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if(emailRegExp.test(email.trim()))	{
      callback()
    }else{
      return callback(  new Error('邮箱格式不对'))
    }
  }else {
    return callback( new Error('邮箱不能为空！'))
  }
}
export var checkEmails=(rule, emails, callback)=>{
  if(emails){
    const emailRegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const list = emails.split('\n').filter(email => email.trim() !== '')
    for(let email of list){
      if(!emailRegExp.test(email.trim()))	{
        return callback(  new Error('邮箱格式不对'))
      }
    }
    return callback()
  }else {
    return callback( new Error('邮箱不能为空！'))
  }
}

// 是否是数字
export var checkIsIntNumber=(rule, value, callback)=>{
  if(value){
    let reg = /^[1-9]\d*$/;
    if(reg.test(value))	{
      callback()
    }else{
      return callback(  new Error('请填写数字'))
    }
  }else {
    return callback(  new Error('样本数量不为空'))
  }
}
// 是否是日期
export var checkDate = (rule, value, callback) => {
  // 修改正则表达式以适应 yyyy-m-d 和 yyyy-mm-dd 格式，同时支持时间部分
  let datePattern = /^\d{4}-(?:0?[1-9]|1[0-2])-(?:0?[1-9]|[12]\d|3[01])(?: \d{2}:\d{2}:\d{2})?$/;

  if (datePattern.test(value)) {
    let [datePart, timePart] = value.split(' ');

    // 验证日期部分
    let [year, month, day] = datePart.split('-').map(Number);
    let dateOnly = new Date(year, month - 1, day);

    // 检查是否为有效日期
    if (isNaN(dateOnly.getTime()) || dateOnly.getFullYear() !== year || dateOnly.getMonth() + 1 !== month || dateOnly.getDate() !== day) {
      return callback(new Error('无效的日期格式'));
    }

    // 如果有时间部分，验证时间部分
    if (timePart) {
      let [hours, minutes, seconds] = timePart.split(':').map(Number);
      if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59 || seconds < 0 || seconds > 59) {
        return callback(new Error('时间格式错误，必须为HH:MM:SS'));
      }
    }
    callback();
  } else {
    return callback(new Error('日期格式必须为YYYY-MM-DD或YYYY-MM-DD HH:MM:SS'));
  }
};
// 是否是大于0的数字
export var checkNum=(rule, value, callback)=>{
  if(!value && value !== 0){
    return callback();
  }
  if (isNaN(value)) {
    return callback(new Error('请输入数字值'));
  }
  if (value <= 0) {
    return callback(new Error('输入值必须大于0'));
  }
  return callback();
}
export var checkSumAmount=(rule, value,array1,array2, callback,boolune)=>{
  if(!value && value !== 0){
    return callback();
  }
  if (isNaN(value)) {
    return callback(new Error('请输入数字值'));
  }
  if (boolune) {
    if (value <= 0) {
      return callback(new Error('输入值必须大于0'));
    }
  } else {
    if (value < 0) {
      return callback(new Error('输入值必须为正数'));
    }
  }
  
  let num = 0
  let list = array2.filter(item => array1.includes(item))
  for(let item of list){
    if(!isNaN(item.numberOfExperiment)){
      num = num + Number(item.numberOfExperiment)
    }
  }
  if(Number(value) !== num){
    return callback(new Error(`项目金额与实验过程金额不一致`));
  }
  return callback();
}



export var checkInclude=(rule, value, callback,items,array)=>{
  for(let item of items){
    if(array.includes(item) && !value.includes(item)){
      return callback(new Error(item + '为必选项，请勾选'));
    }
  }
  return callback();
}

export var checkSize = (rule, value, callback, min) => {
  if (value === 'NA') {
    return callback();
  }

  // 检查单位是否有效
  const unit = value.replace(/^[0-9]*\.?[0-9]*/, '').trim(); // 支持小数
  if (unit && !['w', 'W', 'm', 'M'].includes(unit)) {
    return callback(new Error('请输入有效的单位 (W/M)'));
  }

  const cleanedValue = value.replace(/[wWmM]$/, '').trim();
  // 检查去除单位后的值是否为数字
  if (isNaN(cleanedValue)) {
    return callback(new Error('请输入数字值'));
  }

  // 将输入值转换为数值
  let numericValue = parseFloat(cleanedValue);
  if (numericValue <= 0) {
    return callback(new Error('输入值必须大于0'));
  }

  // 根据单位转换数值
  switch (unit.toLowerCase()) {
    case 'w':
      numericValue *= 10000;
      break;
    case 'm':
      numericValue *= 1000000;
      break;
    default:
        break;
  }

  // 如果传入了 min 参数，进行大小验证
  if (min !== undefined && min !== null) {
    if (numericValue < min) {
      return callback(new Error(`输入值必须大于 ${min}`));
    }
  }

  // 如果没有问题，调用 callback
  return callback();
}
export var checkNumber=(rule, value, callback)=>{
  if (isNaN(value)) {
    return callback(new Error('请输入数字值'));
  }
  if (value < 0) {
    return callback(new Error('金额必须不小于0'));
  }
  return callback();
}
export var checkMinMax = (rule, value, callback, min, max) => {
  if (isNaN(value)) {
    return callback(new Error('请输入数字值'));
  }
  if (value <= 0) {
    return callback(new Error('输入值必须大于0'));
  }
  if (min && value < min) {
    return callback(new Error(`输入值必须不小于 ${min}`));
  }
  if (max && value > max) {
    return callback(new Error(`输入值必须不大于 ${max}`));
  }
  return callback();
}
export var checkSum = (rule, value, callback,min, max,array1, array2) => {
  if (isNaN(value)) {
    return callback(new Error('请输入数字值'));
  }
  if (value <= 0) {
    return callback(new Error('输入值必须大于0'));
  }
  if (min && value < min) {
    return callback(new Error(`输入值必须不小于 ${min}`));
  }
  if (max && value > max) {
    return callback(new Error(`输入值必须不大于 ${max}`));
  }
  let num = 0
  let list = array2.filter(item => array1.includes(item))
  for(let item of list){
    if(!isNaN(item.numberOfExperiment)){
      num = num + Number(item.numberOfExperiment)
    }
  }
  if(Number(value) !== num){
    return callback(new Error(`样品数量与实验过程总样品数量不一致`));
  }
  return callback();
}

export var check = (rule, value, number,sum, callback) => {
  if (isNaN(value)) {
    return callback(new Error('请输入数字值'));
  }
  if (!Number.isInteger(Number(value))) {
    return callback(new Error('请输入整数'));
  }
  if (Number(value) < 0) {
    return callback(new Error('数字必须不小于0'));
  }
  if(number){
    if (Number(value) > number) {
      return callback(new Error('申领数量超过限制'));
    }
  }
  if(sum){
    if (Number(sum) > number) {
      return callback(new Error('总申领数量超过剩余数量'));
    }
  }
  return callback();
};
export var checkDates = (rule, value, callback) => {
  let datePattern = /^\d{4}-\d{2}-\d{2}$/;
  let dates = value.split(',');
  for (let date of dates) {
    date = date.trim();
    if (!datePattern.test(date)) {
      return callback(new Error('日期格式必须为YYYY-MM-DD'));
    }
    let dateOnly = new Date(date);
    let [year, month, day] = date.split('-').map(Number);
    if (
        dateOnly.getFullYear() !== year ||
        dateOnly.getMonth() + 1 !== month || // Note: getMonth() is zero-based
        dateOnly.getDate() !== day
    ) {
      return callback(new Error('无效的日期格式'));
    }
  }
  callback();
};
// 团队费用合同金额上限校验：测序分析不超过800，纯分析不超过1500
export var getTeamContractAmountLimit = (formContract) => {
  if (formContract.contractType !== 'TEAM') {
    return null;
  }
  if (formContract.projectType === '纯分析' && formContract.pureAnalysisInfo.pureAnalysisType === 'PURE_ANALYSIS') {
    return 1500;
  }
  if (formContract.projectType === '测序分析') {
    return 800;
  }
  return null;
}
//返回超限错误信息，未超限（或非团队费用合同）时返回null，由调用方拦截提交
export var checkTeamContractAmount = (formContract, value) => {
  const max = getTeamContractAmountLimit(formContract);
  if (max === null || value === '' || value === null || value === undefined || isNaN(value)) {
    return null;
  }
  if (Number(value) > max) {
    return `团队费用合同（${formContract.projectType}）金额不能超过${max}`;
  }
  return null;
}
//特殊字符检查
export var checkCharacter = (rule, value, callback) => {
  const characters = ['<', '>', ':', '"', '/', '\\', '|', '?', '*','+'];
  if (value){
    for (let char of characters) {
      if (value.includes(char)){
        return callback(new Error('不能使用特殊字符' + char + '，请检查'));
      }
    }
  }
  return callback();
}